"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 14: SL-1632 (Huang-1 ASIC) - MMC3-like with supervisor
 * ------------------------------------------------------------------ *
 * Gouder SL-1632 board with Huang-1 ASIC (MMC3A clone) plus PAL
 * supervisor register at $A131 that controls CHR A18 lines and
 * switches between MMC3 and VRC2 modes.
 * Used by Samurai Spirits (8-char version).
 * See https://www.nesdev.org/wiki/INES_Mapper_014
 */

function register(Mappers) {
  Mappers[14] = function (nes) {
    this.nes = nes;
  };

  Mappers[14].prototype = new Mappers[4](); // Inherit from MMC3

  Mappers[14].prototype.reset = function () {
    Mappers[4].prototype.reset.apply(this);
    // Supervisor register at $A131:
    // Bit 0: Mapper mode (0=VRC2, 1=MMC3)
    // Bit 1: CHR A18 for PPU $1800-$1FFF
    // Bit 2: CHR A18 for PPU $1000-$17FF
    // Bit 3: CHR A18 for PPU $0000-$0FFF
    // Bits 4-7: unused
    this.supervisorReg = 0x01; // Default to MMC3 mode
    this.chrA18 = [0, 0, 0]; // A18 for $0000, $1000, $1800
  };

  Mappers[14].prototype.write = function (address, value) {
    // Supervisor register at $A131
    if (address === 0xa131) {
      this.supervisorReg = value;
      this.chrA18[0] = (value >> 3) & 1; // CHR A18 for $0000-$0FFF
      this.chrA18[1] = (value >> 2) & 1; // CHR A18 for $1000-$17FF
      this.chrA18[2] = (value >> 1) & 1; // CHR A18 for $1800-$1FFF
      this.mode = value & 1; // 0=VRC2, 1=MMC3
      this.updateChrBanks();
      return;
    }

    // In VRC2 mode, the VRC2 registers overlap with MMC3
    // For now, delegate to MMC3 implementation (MMC3 mode is default)
    // VRC2 mode is not fully implemented
    Mappers[4].prototype.write.apply(this, arguments);
  };

  // Override updateChrBanks to incorporate CHR A18 lines
  Mappers[14].prototype.updateChrBanks = function () {
    var s = this.bankSelect;

    // Apply CHR A18 lines from supervisor register
    var a18_0000 = (this.chrA18[0] << 6) & 0x40; // Bit 6 for $0000-$0FFF
    var a18_1000 = (this.chrA18[1] << 6) & 0x40; // Bit 6 for $1000-$17FF
    var a18_1800 = (this.chrA18[2] << 6) & 0x40; // Bit 6 for $1800-$1FFF

    if (this.chrAddressSelect === 0) {
      // Mode 0: two 2 KB at $0000/$0800, four 1 KB at $1000-$1C00
      this.load1kVromBank((s[0] | a18_0000) & 0xff, 0x0000);
      this.load1kVromBank(((s[0] + 1) | a18_0000) & 0xff, 0x0400);
      this.load1kVromBank((s[1] | a18_0000) & 0xff, 0x0800);
      this.load1kVromBank(((s[1] + 1) | a18_0000) & 0xff, 0x0c00);
      this.load1kVromBank((s[2] | a18_1000) & 0xff, 0x1000);
      this.load1kVromBank((s[3] | a18_1000) & 0xff, 0x1400);
      this.load1kVromBank((s[4] | a18_1800) & 0xff, 0x1800);
      this.load1kVromBank((s[5] | a18_1800) & 0xff, 0x1c00);
    } else {
      // Mode 1: four 1 KB at $0000-$0C00, two 2 KB at $1000/$1800
      this.load1kVromBank((s[2] | a18_0000) & 0xff, 0x0000);
      this.load1kVromBank((s[3] | a18_1000) & 0xff, 0x0400);
      this.load1kVromBank((s[4] | a18_1000) & 0xff, 0x0800);
      this.load1kVromBank((s[5] | a18_1800) & 0xff, 0x0c00);
      this.load1kVromBank(((s[0] | a18_1000) & 0xff) << 1, 0x1000);
      this.load1kVromBank((((s[0] + 1) | a18_1000) & 0xff) << 1, 0x1400);
      this.load1kVromBank(((s[1] | a18_1800) & 0xff) << 1, 0x1800);
      this.load1kVromBank((((s[1] + 1) | a18_1800) & 0xff) << 1, 0x1c00);
    }
  };

  Mappers[14].prototype.toJSON = function () {
    var s = Mappers[4].prototype.toJSON.apply(this);
    s.supervisorReg = this.supervisorReg;
    s.chrA18 = this.chrA18.slice();
    return s;
  };

  Mappers[14].prototype.fromJSON = function (s) {
    Mappers[4].prototype.fromJSON.apply(this, arguments);
    this.supervisorReg = s.supervisorReg;
    this.chrA18 = s.chrA18.slice();
    this.chrA18[0] = (this.supervisorReg >> 3) & 1;
    this.chrA18[1] = (this.supervisorReg >> 2) & 1;
    this.chrA18[2] = (this.supervisorReg >> 1) & 1;
    this.updateChrBanks();
  };
}

module.exports = { register: register };
